export default __webpack_public_path__ + "static/BgImg04-5b229bd11ffa8c4612bf3a064ff33c15.webp";